import axiosInstance from './axiosInstance';

// Uploads inspection photos + notes for a vehicle.
// Uses FormData (not JSON) since we're sending actual image files.
export async function uploadInspection({ vehicleId, loadId, mode, notes, photoFiles }) {
  const formData = new FormData();
  formData.append('vehicle_id', vehicleId);
  formData.append('load_id', loadId);
  formData.append('mode', mode);
  formData.append('notes', notes || '');

photoFiles.forEach((file) => {
  formData.append('photos[]', file); // [] tells PHP to collect these into an array
});

  const response = await axiosInstance.post('/vehicles/upload-inspection.php', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}








// Fetches full details for a single vehicle, including all photos.
export async function getVehicle(id) {
  const response = await axiosInstance.get(`/vehicles/get-vehicle.php?id=${id}`);
  return response.data;
}